// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__25WSb","selected":"Chip_selected__3HhQx"};